import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
const styles = (theme) => ({
  question: {
    color: theme.palette.text.secondary,
    textDecorationLine: "underline",
    cursor: "pointer",
  },
  answer: {
    color: theme.palette.text.secondary,
  },
});

class DecisionTreeBreadrcrumbs extends Component {
  render() {
    let { classes } = this.props;
    const crumbs = [];
    // for (let i = 0; i < this.props.questions.length; i++) {
    this.props.questions.map((question) => {
      if (question.type === "question") {
        crumbs.push(
          <div
            className={classes.question}
            onClick={() => this.props.backToQuestion(question)}
          >
            {question.label}
          </div>
        );
      } else if (question.type === "answer") {
        crumbs.push(
          <div className={classes.answer}>/{question.label}/</div>
        );
      }
    });
    // crumbs.push(
    //   <div
    //     className={classes.question}
    //     onClick={() => this.props.backToQuestion(this.props.questions[i])}
    //   >
    //     {this.props.questions[i].label}
    //   </div>
    //  else if (this.props.answers[i]) {
    //   crumbs.push(
    //     <div className={classes.answer}>/{this.props.answers[i].label}/</div>
    //   );
    // }
    return (
      <div style={{ display: "flex", flexDirection: "row" }}>{crumbs}</div>
    );
  }
}
export default withStyles(styles)(DecisionTreeBreadrcrumbs);
